import React, { cloneElement } from 'react'
import { Subject, fromEvent, merge } from 'rxjs'
import { filter, map } from 'rxjs/operators'
import { Click } from 'front-end-core/services/WindowService'
import { getNode } from 'helpers/dom'
import useBaseState from 'hooks/useBaseState'

const NewPage = fromEvent(window, 'popstate')
const DropdownTrigger = new Subject()
const toggleDropdown = params => DropdownTrigger.next(params)

export const ToggleDropdown = ({ dropdownId, children }) => {
  const onClick = () => toggleDropdown({ id: dropdownId })

  return cloneElement(children, { ...children.props, onClick, 'data-dropdown-ignore': dropdownId })
}

const Dropdown = ({ children, className, id }) => {
  const state = merge(
    Click.pipe(
      // Filter out elements with 'dropdown-ignore' data attribute.
      filter(e => {
        const el = getNode(node => node.hasAttribute('data-dropdown-ignore'))(e.target)
        const _id = el && el.dataset.dropdownIgnore
        return (_id && _id !== id) || !el
      }),
      // Close the dropdown if the user clicks outside it.
      map(() => ({ visible: false }))
    ),
    DropdownTrigger.pipe(
      // Check whether the trigger was for this specific dropdown.
      filter(({ id: _id }) => _id === id),
      // Toggle the dropdown.
      map(() => ({ visible: !visible }))
    ),
    // Close the dropdown if user navigates to a new page.
    NewPage.pipe(map(() => ({ visible: false })))
  )

  const { baseState: { visible } } = useBaseState(
    state,
    { visible: false },
    [id]
  )

  if (!visible) return null

  return (
    <div {...{ className }} data-dropdown-ignore>
      {children}
    </div>
  )
}

export default Dropdown
